// extracted by mini-css-extract-plugin
module.exports = {"heading":"news-block_heading__1ax2G","element":"news-block_element__C7-Xa","subheading":"news-block_subheading__3lSES","list":"news-block_list__1pP4R"};